import { differenceInCalendarDays } from "date-fns";
export const TARGET_EPSILON_PX = 1;
export const MIN_REVEAL_PADDING_PX = 60;

export function toStartOfDayDate(
  value: string | Date | null | undefined
): Date | null {
  if (!value) return null;
  const next = new Date(value);
  if (Number.isNaN(next.getTime())) return null;
  next.setHours(0, 0, 0, 0);
  return next;
}

export function getCalendarDayIndex(targetDay: Date, baseDay: Date): number {
  return Math.max(0, differenceInCalendarDays(targetDay, baseDay));
}

export function clearSpaceScrollFlags(element: HTMLElement) {
  try {
    element.dataset.orchestratingScroll = "0";
    element.dataset.suppressRange = "0";
    delete element.dataset.forcedHalfStart;
    delete element.dataset.forcedHalfEnd;
  } catch {}
}

export function resolvePreferredScrollBehavior(
  requested: ScrollBehavior
): ScrollBehavior {
  if (requested !== "smooth") return "auto";
  if (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return "auto";
  }
  if (typeof navigator !== "undefined") {
    const ua = navigator.userAgent || "";
    const isSafari =
      /Safari/i.test(ua) && !/(Chrome|Chromium|CriOS|Edg|OPR)/i.test(ua);
    if (isSafari) return "auto";
  }
  return "smooth";
}

export function shouldUseManualSmoothScroll(requested: ScrollBehavior): boolean {
  if (requested !== "smooth") return false;
  if (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return false;
  }
  return true;
}
